import axios from "./axios";

class CmsService {
  generateUrlAirtelCms = async (latitude, longitude) => {
    try {
      const response = await axios.post("/cms/airtel/generate_url", {
        latitude,
        longitude,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  reportAirtelCms = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page,
  ) => {
    try {
      const response = await axios.post("/cms/airtel/report", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new CmsService();
